import { render, staticRenderFns } from "./PendingDoctors.vue?vue&type=template&id=d4c0f2fa&scoped=true"
import script from "./PendingDoctors.vue?vue&type=script&lang=js"
export * from "./PendingDoctors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c0f2fa",
  null
  
)

export default component.exports